import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { AcceptTeamInviteResponse, TeamInvitePreview } from "@/api/types";

export function useTeamInvitePreview(token: string) {
  return useQuery({
    queryKey: ["team-invite", token],
    queryFn: () => api.get(`team_invites/${token}`).json<TeamInvitePreview>(),
    enabled: token.length > 0,
    retry: false,
    staleTime: 60_000,
  });
}

export function useAcceptTeamInvite(token: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post(`team_invites/${token}/accept`).json<AcceptTeamInviteResponse>(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["me"] });
      void queryClient.invalidateQueries({ queryKey: ["dashboard"] });
    },
  });
}
